import { useTranslation } from "react-i18next";
import LegalPage from "@/components/LegalPage";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const keys = [
    "controller",
    "data",
    "purpose",
    "sharing",
    "transfers",
    "retention",
    "rights",
    "security",
    "changes",
  ];
  return (
    <LegalPage
      title={t("pages.privacy.title")}
      updated={t("pages.privacy.updated")}
      intro={t("pages.privacy.intro")}
      sectionKeys={keys}
      i18nRoot="pages.privacy.sections"
      testIdRoot="privacy"
    />
  );
}
